// src/seo/SeoHead.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "EstateGhar";
const SITE_URL = "https://www.estateghar.com"; // ⚠️ change to your real domain

export default function SeoHead({
  title,
  description,
  canonicalPath,
  robots = "index, follow",
  image,
  jsonLd,
}) {
  const canonical = canonicalPath ? `${SITE_URL}${canonicalPath}` : SITE_URL;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* JSON-LD blocks */}
      {jsonLd &&
        jsonLd.map((data, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))}
    </Helmet>
  );
}